import {
    createStyles,
    Table,
    Progress,
    Anchor,
    Text,
    Group,
    ScrollArea,
    Box,
    Flex,
    ActionIcon,
    Skeleton,
} from "@mantine/core";
import { useElementSize } from "@mantine/hooks";
import { IconExternalLink, IconNavigation } from "@tabler/icons";
import Link from "next/link";
import { useEffect } from "react";
import { formatDateAgo, formatTimeTaken } from "../common/commonfunc";

const useStyles = createStyles((theme) => ({
    progressBar: {
        "&:not(:first-of-type)": {
            borderLeft: `3px solid ${
                theme.colorScheme === "dark"
                    ? theme.colors.dark[7]
                    : theme.white
            }`,
        },
    },
    header: {
        position: "sticky",
        top: 0,
        backgroundColor:
            theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
        transition: "box-shadow 150ms ease",
        zIndex: 1,

        "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            borderBottom: `1px solid ${
                theme.colorScheme === "dark"
                    ? theme.colors.dark[3]
                    : theme.colors.gray[2]
            }`,
        },
    },
}));

export function TestAttemptsTable({ current_analytics }) {
    const { classes, theme } = useStyles();
    const { ref, width, height } = useElementSize();
    useEffect(() => {}, [width, height, current_analytics]);
    console.log("current_analytics", current_analytics);

    // if (!!!current_analytics) {
    //     return <Skeleton width={"100%"} height={"100%"} />;
    // }

    let rows = null;
    if (!!current_analytics)
        rows = current_analytics.map((row, idx) => {
            const {
                id: analyticsId,
                current_test: {
                    title,
                    test_start_ts,
                    test_end_ts,
                    testrules: { totalMarks, totalQuestions },
                },
                scorecard: {
                    marks_obtained,
                    num_correct_question,
                    num_negative_question,
                    num_unattempted_question,
                },
            } = row;
            // const totalQuestions = row.questions.total;
            const positiveQuestions =
                100 * (num_correct_question / totalQuestions);
            const negativeQuestions =
                100 * (num_negative_question / totalQuestions);
            const unattemptedQuestions =
                100 * (num_unattempted_question / totalQuestions);
            const timeTaken = test_end_ts - test_start_ts;
            const report_link = "/testanalytics/" + analyticsId;
            const marks_percent = (100 * (marks_obtained / totalMarks)).toFixed(
                1
            );
            const date_ago = formatDateAgo(test_start_ts);
            const time_ago = formatTimeTaken(timeTaken);

            return (
                <tr key={analyticsId}>
                    <td>
                        <Flex align={"center"}>
                            <Link href={report_link} passHref legacyBehavior>
                                <Anchor about={title} aria-label={title}>
                                    {title}
                                </Anchor>
                            </Link>
                            <Link href={report_link}>
                                <ActionIcon color={"blue"}>
                                    <IconExternalLink size={18} />
                                </ActionIcon>
                            </Link>
                        </Flex>
                    </td>
                    <td>{date_ago}</td>
                    <td>{time_ago}</td>
                    <td>{marks_percent}%</td>
                    <td style={{ padding: 10, position: "relative" }}>
                        <Box style={{ position: "relative" }}>
                            {positiveQuestions > 0 && (
                                <Text
                                    size="xs"
                                    color="teal"
                                    weight={700}
                                    style={{
                                        position: "absolute",
                                        top: -15,
                                        left: 0,
                                    }}
                                >
                                    {positiveQuestions.toFixed(1)}%
                                </Text>
                            )}
                            {unattemptedQuestions > 0 && (
                                <Text
                                    size="xs"
                                    color="red"
                                    weight={700}
                                    style={{
                                        position: "absolute",
                                        top: -15,
                                        left: positiveQuestions + "%",
                                    }}
                                >
                                    {unattemptedQuestions.toFixed(1)}%
                                </Text>
                            )}
                            {negativeQuestions > 0 && (
                                <Text
                                    size="xs"
                                    color="red"
                                    weight={700}
                                    style={{
                                        position: "absolute",
                                        top: -15,
                                        right: 0,
                                    }}
                                >
                                    {negativeQuestions.toFixed(1)}%
                                </Text>
                            )}
                        </Box>
                        <Box
                            sx={(th) => ({
                                position: "relative",
                                top: 5,
                            })}
                        >
                            <Progress
                                classNames={{ bar: classes.progressBar }}
                                sections={[
                                    {
                                        value: positiveQuestions,
                                        color:
                                            theme.colorScheme === "dark"
                                                ? theme.colors.teal[9]
                                                : theme.colors.teal[6],
                                        tooltip: "Correctly answered",
                                    },
                                    {
                                        value: unattemptedQuestions,
                                        color:
                                            theme.colorScheme === "dark"
                                                ? theme.colors.orange[9]
                                                : theme.colors.orange[6],
                                        tooltip: "Not answered",
                                    },
                                    {
                                        value: negativeQuestions,
                                        color:
                                            theme.colorScheme === "dark"
                                                ? theme.colors.red[9]
                                                : theme.colors.red[6],
                                        tooltip: "Incorrectly answered",
                                    },
                                ]}
                            />
                        </Box>
                    </td>
                    <td>
                        <Link href={report_link}>Check Report</Link>
                    </td>
                </tr>
            );
        });

    return (
        <Box p={10} ref={ref} style={{ height: 300 }}>
            {!!!current_analytics && (
                <Skeleton width={"100%"} height={"100%"} />
            )}
            {!!rows && (
                <ScrollArea style={{ width, height }}>
                    <Table
                        sx={{ minWidth: 800 }}
                        verticalSpacing="xs"
                        highlightOnHover
                    >
                        <thead className={classes.header}>
                            <tr>
                                <th>Test Name</th>
                                <th>Test Taken</th>
                                <th>Time Taken</th>
                                <th>Marks Scored</th>
                                <th>Marks Distribution</th>
                                <th>Detailed Report</th>
                            </tr>
                        </thead>
                        <tbody>{rows}</tbody>
                    </Table>
                </ScrollArea>
            )}
        </Box>
    );
}
